// The wrapper every /render/* route shares: establish the operator's session,
// then get out of the way.
//
// Phase 1.5's whole claim is that a new emailable report costs a route and a
// registry row — no migration, no SECURITY DEFINER function per report. This
// component is the part that makes that true. It does the two things every
// render route needs identically (redeem the token, become the operator) and
// nothing else, so a report page can be mounted here unchanged and read
// exactly as it does on screen.
//
// While the session is being established this component owns the render
// verdict; once children mount, the report page is the ONLY writer. Children
// are deliberately not rendered until the session is ready — a report page
// that mounted session-less would fire its queries as `anon`, get empty
// results under RLS, and honestly report `empty` for a document that is not
// empty at all.
import type { ReactNode } from 'react'
import { useRenderSession } from '@/hooks/useRenderSession'
import { useReportReady } from '@/hooks/useReportReady'

export default function RenderRoute({ children }: { children: ReactNode }) {
  const session = useRenderSession()

  // null once ready: the report page takes over as the single writer.
  useReportReady(
    session === 'failed'  ? 'error'
    : session === 'pending' ? 'pending'
    :                         null,
  )

  return session === 'ready' ? <>{children}</> : null
}
